/** Delete a tenant. */
export const tenantDeleteSpec = {
    uri: '/t/[tenant]',
    method: 'DELETE',
    adminOnly: true,
};
